module.exports = __webpack_public_path__ + "img/cloudIcon.046c01c4.svg";